module.exports = __webpack_public_path__ + "img/print_inDrawing.9cb3856c.png";